<template>
  <section>
    <GroupCheckboxesWithValidation
      v-model="checkedMilieuxInteretsParticuliersLabels"
      :label="$t('instruction.milieu-interet-particulier')"
      :data="allMilieuxInteretParticulierLabels()"
      :vertical-display="true"
      :input-label="$t('instruction.AUTRE')"
      :ext-input-value="internalProjet.milieuInteretParticulierAutre"
      vid="demarche"
      :disabled="readOnly"
      @manual-change="changeMilieuxInterets"
      @input-change="changeMilieuxInteretsAutre"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { PropType } from "vue"
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import GroupCheckboxesWithValidation from "@/views/inputs/GroupCheckBoxesWithValidation.vue"
import { EnumHelper } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "InstructionMilieuxParticuliers",
  components: {
    GroupCheckboxesWithValidation,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["projet-annuel-updated"],
  data() {
    return {
      internalProjet: new ProjetAnnuelDTO(),
      allMilieuxInteretParticulier: EnumHelper.allMilieuxInteretParticulier,
      checkedMilieuxInteretsParticuliersLabels: [] as string[],
    }
  },
  watch: {
    projetAnnuel(): void {
      this.refreshInternalProject()
    },
  },
  created(): void {
    this.refreshInternalProject()
  },
  methods: {
    refreshInternalProject(): void {
      this.internalProjet = { ...this.projetAnnuel }
      this.refreshChecked()
    },

    refreshChecked(): void {
      this.checkedMilieuxInteretsParticuliersLabels =
        this.internalProjet.milieuInteretParticulier.map((milieuParticulier) => {
          return this.$t("instruction." + milieuParticulier).toString()
        })
      if (this.internalProjet.milieuInteretParticulierAutre) {
        this.checkedMilieuxInteretsParticuliersLabels.push(this.$t("instruction.AUTRE").toString())
      }
    },

    allMilieuxInteretParticulierLabels(): string[] {
      return this.allMilieuxInteretParticulier.map((milieuParticulier) => {
        return this.$t("instruction." + milieuParticulier).toString()
      })
    },

    changeMilieuxInterets(): void {
      const updatedProjet = { ...this.internalProjet }
      updatedProjet.milieuInteretParticulier = this.allMilieuxInteretParticulier.filter(
        (milieuParticulier) => {
          return (
            this.checkedMilieuxInteretsParticuliersLabels.indexOf(
              this.$t("instruction." + milieuParticulier).toString(),
            ) > -1
          )
        },
      )
      if (
        this.checkedMilieuxInteretsParticuliersLabels.indexOf(
          this.$t("instruction.AUTRE").toString(),
        ) === -1
      ) {
        updatedProjet.milieuInteretParticulierAutre = ""
      }
      this.$emit("projet-annuel-updated", updatedProjet)
    },

    changeMilieuxInteretsAutre(newValue: string): void {
      const updatedProjet = { ...this.internalProjet }
      
      const indexAutre = this.checkedMilieuxInteretsParticuliersLabels.indexOf(
        this.$t("instruction.AUTRE").toString(),
      )
      
      // Only update value if AUTRE checkbox is checked
      if (indexAutre !== -1) {
        updatedProjet.milieuInteretParticulierAutre = newValue
      } else {
        updatedProjet.milieuInteretParticulierAutre = ""
      }
      
      this.$emit("projet-annuel-updated", updatedProjet)
    },
  },
})
</script>
